import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    saveHomework: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/edit/save", vo, successCallback, failureCallback);
    }
};

export default EditService;
